import { MenuItem } from '@headlessui/react'
import React, { useState } from 'react'
import { FaCaretDown } from 'react-icons/fa'
import { MyLink } from '../MyLink'

export const HelperNavBarSmall = () => {
    
    const [ isExpand, setIsExpand ] = useState(false)

  return (
    <>
        <li>
            <div className='flex justify-center'>
                <button type="button" onClick={() => setIsExpand(!isExpand)} 
                    className=" flex justify-center px-2 py-2  text-orange-500">
                    <strong className='flex'>Services<FaCaretDown className="h-5 w-5"/></strong>
                </button>
            </div>
            {isExpand &&
                <ul className='relative space-y-2'>
                    <MenuItem>
                        <MyLink href="/sg/part-time-cleaner-singapore/professional-house-cleaning" prefetch={false} className='text-orange-400 text-sm p-2 block'>
                            Professional House Cleaning
                        </MyLink>
                    </MenuItem>
                    <MenuItem>
                        <MyLink href="/sg/part-time-cleaner-singapore/move-in-move-out-cleaning" prefetch={false} className='text-orange-400 text-sm p-2 block'>
                            Move Out Cleaning
                        </MyLink>
                    </MenuItem>
                    <MenuItem>
                        <MyLink href="/sg/part-time-cleaner-singapore/spring-cleaning" prefetch={false} className='text-orange-400 text-sm p-2 block'>
                            Spring Cleaning
                        </MyLink>
                    </MenuItem>
                    <MenuItem>
                        <MyLink href="/sg/part-time-cleaner-singapore/part-time-helper-for-cooking" prefetch={false} className='text-orange-400 text-sm p-2 block'>
                            Cooking Assistance
                        </MyLink>
                    </MenuItem>
                    <MenuItem>
                        <MyLink href="/sg/part-time-cleaner-singapore/part-time-babysitter-singapore" prefetch={false} className='text-orange-400 text-sm p-2 block'>
                            Babysitter
                        </MyLink>
                    </MenuItem>
                    <MenuItem>
                        <MyLink href="/sg/part-time-cleaner-singapore/elderly-care" prefetch={false} className='text-orange-400 text-sm p-2 block'>
                            Elderly Caregiver
                        </MyLink>
                    </MenuItem>
                </ul>    
            }
        </li>
        <MenuItem> 
            <MyLink href="/sg/part-time-cleaner-singapore/part-time-cleaner-rates-singapore" prefetch={false} className="flex justify-center px-2 py-2 text-orange-500" aria-current="page">
                Rates                   
            </MyLink>
        </MenuItem>
        <MenuItem>
            <MyLink href="/sg/blogs/house-keeping"
                    prefetch={false} className="flex justify-center px-2 py-2 text-orange-600" 
                    aria-label="House Keeping Blogs">
                Blogs                     
            </MyLink>            
        </MenuItem>
    </>
  )
}
